module.exports = __webpack_public_path__ + "img/omerFlirting.f1d29ba8.gif";